/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} My_Integrations_Rename_ActionInputs */



/**
* | output |
* | --- |
* | "Rename" |
*
* @param {My_Integrations_Rename_ActionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const my_integrations_rename_action = /** @type {((inputs?: My_Integrations_Rename_ActionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<My_Integrations_Rename_ActionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Umbenennen")
	return /** @type {LocalizedString} */ ("Rename")
});